import Select from 'react-select';
import {getReactSelectDefaultProps} from 'config/react-select';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import _ from 'lodash';
import {fetchVorgesetzterUserDataSource, switchVorgesetzterUserHandler} from 'module/SessionInfo/api/SwitchVorgesetzterUserAPI';
import {doAfterNextSessionInfoRefreshDone, forceRefreshSessionInfo} from 'module/SessionInfo/api/SessionInfoAPI';

const mapToOption = d => d && d.id && ({value: d.id, label: d.displayName}) || null;
export const VorgesetzterUserSelect = ({vorgesetzterUser}) => {
	const [loading, setLoading] = useState(false);
	const [options, setOptions] = useState([]);
	const value = useMemo(() => mapToOption(vorgesetzterUser), [vorgesetzterUser]);
	useEffect(() => {
		fetchVorgesetzterUserDataSource()
			.then(({data}) =>
				setOptions(_.map(data, mapToOption)),
			);
	}, []);
	const onChange = useCallback(obj => {
		const req = switchVorgesetzterUserHandler(obj && obj.value);
		setLoading(true);
		req.then(() => {
			doAfterNextSessionInfoRefreshDone(() => setLoading(false));
			forceRefreshSessionInfo();
		});
	}, []);
	return (
		<Select{...getReactSelectDefaultProps({
			isClearable: true,
			isLoading: loading,
			options,
			value,
			onChange,
		})}/>
	);
};